import { render } from "./AdminNotificationView.vue?vue&type=template&id=56eba378&scoped=true&ts=true"
import script from "./AdminNotificationView.vue?vue&type=script&lang=ts"
export * from "./AdminNotificationView.vue?vue&type=script&lang=ts"

import "./AdminNotificationView.vue?vue&type=style&index=0&id=56eba378&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56eba378"]])

export default __exports__